import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import * as React from "react";
import { ProductWrapperValuation } from "../../../../../../Wrap/Models/Models/Business/AssetUnderManagement/ProductWrapperValuation";

interface IWrapperSummaryDonutProps {
    data: ProductWrapperValuation[];
}

const options = (data: ProductWrapperValuation[]): Highcharts.Options => {
    return {
        chart: {
            renderTo: "container",
            type: "pie",
            backgroundColor: "transparent",
            height: 240,
        },
        title: {
            text: "",
        },
        navigator: {
            enabled: false,
        },
        rangeSelector: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        yAxis: {
            title: {
                text: "Total percent market share",
            },
        },
        plotOptions: {
            pie: {
                shadow: false,
            },
        },
        tooltip: {
            formatter: function () {
                return "<b>" + this.point.x + "</b>: " + this.y + " %";
            },
        },
        series: [
            {
                name: "Asset Classes",
                type: "pie",
                data: data.map((ele) => ({
                    color: ele.Color,
                    x: ele.Label,
                    y: ele.Allocation,
                })),
                innerSize: "90%",
                selected: false,
                showInLegend: false,
                dataLabels: {
                    enabled: false,
                },
            },
        ],
    };
};

export const WrapperSummaryDonut = (props: IWrapperSummaryDonutProps) => {
    if (!props.data || props.data.length == 0) {return null;}

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options(props.data)} />
        </>
    );
};
